export default ["Remote", "On Premise", "Hybrid"];
